import React, { useState, useEffect, useCallback } from "react";
import { ToastContainer, toast } from "react-toastify";
import {
  TextInput,
  SelectInput,
  FormatPhoneNumber,
} from "../components/common/UI/Inputs/InputControls";
import DatePickerComponent from "../components/common/UI/Inputs/InputControls/DateInput.jsx";
import "react-toastify/dist/ReactToastify.css";
import registerSchema from "../validation/registerSchema";
import signup from "../../src/assets/images/banner-login.jpg";
import PasswordField from "../components/common/UI/Inputs/InputControls/PasswordTextbox.jsx";
import { useSelector, useDispatch } from "react-redux";
import { masterActions, authActions } from "../_store";
import { encryptData } from "../utils/encryptDecrypt";
import { registerActions } from "../_store/userRegister.slice.js";
import { useNavigate, useLocation } from "react-router-dom";
import { validateUserEmailActions } from "../_store/userEmailExsist.slice.js";
import NotificationService from "../ui/ui-modal-notification.js";
import { ReactNotifications } from "react-notifications-component";
import { showAlert } from "../components/common/showAlert.js";
import useFullPageLoader from "../hooks/useFullPageLoader";
import Logo from "../assets/logo1.png";
import LockIcon from "../assets/images/lock-icon.svg"
import userIcon from "../assets/images/user.svg"
import inmatelogo from '../assets/images/logo-portrait@2x.png';
import ConfirmationModal from "../components/PopupComponent/ConfirmationModal.jsx";
import { decryptDataInviteLink } from "../utils/encryptDecrypt";
import { EventLog } from "../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../utils/routeTracker.js";
import useIPAddress from "../hooks/useIPAddress.jsx";
import useBrowserType from "../hooks/useBrowserType.jsx";
import { getStoredValue, setStoredValue } from "../_helpers/storagehelper.js";

function Register() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const stateDrpList = useSelector((x) => x.master.stateDrpList);
  const [stateList, setStateList] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formState, setFormState] = useState({
    publicUserID: 0,
    firstName: "",
    lastName: "",
    userName: "",
    userPassword: "",
    email: "",
    cellPhone: "",
    address1: "",
    address2: "",
    city: "",
    stateName: "",
    zip: "",
    dob: "",
    gender: "",
    signUpBrowserType: "",
    signUpIPAddress: "192.67.34.143",
    isSALoginAsPU: 0,
    isSubscribeMail: 1,
    activeStatus: 1,
    action: 1,
    createdBy: 0,
    isAgeVerified: 0,
    isRegisteredFromInvite: 1,
    inmateInvitePublicUserID: 2,
    userActivate: 1,
    isSucceed: 0,
    inviteGUID: 0,
    inviteThrough: 0,
    confirmEmail: "",
    confirmPassword: "",
    notificationConditionVerified: true,
    id: 0,
    puPasswordLogID: 0,
    InviteLink: ""
  });
  const location = useLocation();
  const [currentField, setCurrentField] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: "",
    messageHTML: "",
    message: "",
    showCancelButton: true,
    onConfirm: () => { },
    onCancel: () => { }
  });
  const [inmateKioskInvite, setInmateKioskInvite] = useState(
    {
      PublicUserID: 0,
      InmateID: 0,
      InviteGUID: "",
      InmateInvitePublicUserID: null,
      InmateFullName: "",
      PUIConnectionID: 0,
      ConnectionStatusID: 0,
      RelationshipStatus: "",
      InmateStatus: 0,
      FacilityID: 0,
      StateNameID: 0,
      InmateResidentId: 0,
      ContactNumberOrEmail: "",
      InviteThrough: "",
      FirstName: "",
      LastName: "",
      InviteLink: "",
      IsRegisteredFromInvite: 0,
    }
  );
  const ip = useIPAddress();
  const browser = useBrowserType();
  const [errors, setErrors] = useState({});
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [isInvitedURL] = useState(false);
  const [isInviteLinkModal, setIsInviteLinkModal] = useState(false);

  // Calculate the date 18 years ago from today
  const today = new Date();
  const maxDate = new Date(today.setFullYear(today.getFullYear() - 18));

  // Gender dropdown component options
  const genderOptions = [
    { value: "1", label: "Male" },
    { value: "2", label: "Female" },
  ];

  // Response for Username or email already exists or not
  const { userExists, loading, error } = useSelector(
    (state) => state.validateUserEmail
  );

  const { isLoading, isError, errorMessage, registerData } = useSelector(
    (state) => state.register
  );


  // In this below useEffect we cal and getBrowserType function and store value into state
  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      const ipAddress = ip;
      const browserType = browser;

      // Grouping the state updates to avoid conflicts
      if (isMounted) {
        setFormState((prevForm) => ({
          ...prevForm,
          signUpIPAddress: ipAddress,
          signUpBrowserType: browserType,
        }));
      }
    };

    fetchData();

    return () => {
      isMounted = false; // cleanup on unmount
    };
  }, [ip, browser]);

  useEffect(() => {
    // Extract query parameters
    const searchParams = new URLSearchParams(location.search);
    //const isRegisterAsMobile = searchParams.get("IsRegisterAsMobile");
    //const isRedirectedInvitedURL = searchParams.get("IsRedirectedInvitedURL");

    const inviteLink = searchParams.get("InviteLink");
    if (inviteLink !== null && inviteLink.trim() !== "") {
      const decodedInviteLink = decryptDataInviteLink(decodeURIComponent(inviteLink));
      if (decodedInviteLink != "") {
        setIsInviteLinkModal(false);
        const inviteLinkInfo = decodedInviteLink.split('&');
        // Assuming the first part is InmateID and the second part is InviteGUID
        const inmateID = inviteLinkInfo[0];
        const inviteGUID = inviteLinkInfo[1];

        // Perform the action with the decoded data
        dispatch(
          authActions.InviteLink({
            InmateID: parseInt(inmateID), // Using decoded InmateID
            InviteGUID: inviteGUID, // Using decoded InviteGUID
            PublicUserId: 0, // Set default as per original C# logic
          })
        )
          .then((response) => {
            // Assuming response contains inmate details
            if (response.payload !== null && response.payload !== undefined) {
              setStoredValue("IsInvitedURL", true);
              setInmateKioskInvite((prevState) => ({
                ...prevState,
                ...response.payload,
                InviteLink: inviteLink,
                IsRegisteredFromInvite: ((response.payload?.InviteThrough == "Mobile") ? 1 : (response.payload?.InviteThrough == "Email") ? 2 : 0),
              }));
            }
            else {
              setStoredValue("IsInvitedURL", false);
            }
          })
      }
      else {
        setIsInviteLinkModal(true);
      }
    }
  }, [location]);

  // Used for get StateList
  useEffect(() => {
    showLoader();
    dispatch(masterActions.GetStateList());
  }, [dispatch]);

  // Assign state values to stateList state
  useEffect(() => {
    let stateList = [...stateDrpList];
    setStateList(stateList);
    hideLoader();
  }, [stateDrpList]);

  // Get Registration status and display message
  useEffect(() => {
    if (registerData === 1) {
      const email = formState?.email;
      setModalContent({
        title: "Registration Successful!",
        messageHTML: `You have successfully registered with Inmate Inbox. Please check the confirmation E-mail sent to <strong>${email}</strong> and activate your account.`,
        message: ``,
        showCancelButton: false, // No "No" button
        onConfirm: () => {
          // Redirect to Login
          const searchParams = new URLSearchParams(location.search);
          const inviteLink = searchParams.get("InviteLink");
          if (inviteLink !== null) {
            navigate(`/public/Login?InviteLink=${encodeURIComponent(inviteLink)}&IsRedirectedInvitedURL=true`);
            storeCurrentRoute("/public/Login");
          } else {
            navigate("/public/Login");
            storeCurrentRoute("/public/Login");
          }
        },
      });
      setShowModal(true);
      dispatch(registerActions.clearRegisterResponse());
    } else if (registerData === -1) {
      setModalContent({
        title: "Registration Failed",
        messageHTML: `<h6>Registration Insert failed. ${error || ""}</h6>`,
        message: "Please enter the e-mail you used to sign up for your Inmate Inbox account. We’ll send Username to the registered e-mail.",
        showCancelButton: false, // No "No" button
        onConfirm: () => setShowModal(false),
      });
      setShowModal(true);
      dispatch(registerActions.clearRegisterResponse());
    } else if (registerData === -2) {
      setModalContent({
        title: "Error",
        messageHTML: "",
        message: "E-mail already exists.",
        showCancelButton: false, // No "No" button
        onConfirm: () => setShowModal(false),
      });
      setShowModal(true);
      dispatch(registerActions.clearRegisterResponse());
    } else if (registerData === -3) {
      setModalContent({
        title: "Error",
        messageHTML: "",
        message: "Username already exists.",
        showCancelButton: false, // No "No" button
        onConfirm: () => setShowModal(false),
      });
      setShowModal(true);
      dispatch(registerActions.clearRegisterResponse());
    }
    hideLoader();
  }, [registerData]);

  // Used for validate username or email already exsists or not
  useEffect(() => {
    if (!loading) {
      // Handle userExists state for username
      if (
        userExists !== null &&
        formState.userName &&
        currentField === "userName"
      ) {
        if (userExists === 1) {
          setErrors((prev) => ({
            ...prev,
            userName: "Username already exists.",
          }));
        } else if (userExists === -1 && !errors.userName) {
          setErrors((prev) => ({
            ...prev,
            userName: "", // Clear the error if the username doesn't exist
          }));
        }
      }

      // Handle userExists state for email
      if (userExists !== null && formState.email && currentField === "email") {
        if (userExists === 2) {
          setErrors((prev) => ({
            ...prev,
            email: "E-mail already exists.",
          }));
        } else if (errors?.email === "Please enter valid e-mail.") {
        } else if (
          userExists === -2 &&
          errors?.email !== "Please enter a valid e-mail."
        ) {
          setErrors((prev) => ({
            ...prev,
            email: "", // Clear the error if the email doesn't exist
          }));
        }
      }
    }
  }, [userExists, formState.userName, formState.email, loading]);

  // Dropdown common onChange function
  const handleSelectChange = (selectedOption, fieldName) => {
    const selectedValue = Array.isArray(selectedOption)
      ? selectedOption.map((option) => option.value) // For multi-select, store an array of values
      : selectedOption?.value ?? ""; // For single-select, store a single value or an empty string

    // Update the accountState with the selected value(s)
    setFormState((prevState) => ({
      ...prevState,
      [fieldName]: selectedValue, // Store the updated value for the field
    }));

    setErrors((prev) => ({
      ...prev,
      [fieldName]: "", // Clear the specific field error
    }));
  };

  // Used for validate ever control cursor leave
  const handleBlur = async (e) => {
    const { name, value } = e.target;

    try {
      // Validate the field using the Joi schema and handle both required and other validation
      await registerSchema.validateAsync(
        { [name]: value },
        { abortEarly: false }
      );

      // Clear error if validation passes
      setErrors((prev) => ({
        ...prev,
        [name]: "", // Clear the specific field error
      }));
    } catch (err) {
      // Find the error that matches the current field name
      const fieldError = err.details.find((error) => error.path.includes(name));

      if (fieldError) {
        setErrors((prev) => ({
          ...prev,
          [name]: fieldError.message, // Set the specific field error from Joi
        }));
      }
    }

    // Additional validation for confirmEmail and confirmPassword to check if they match
    if (name === "confirmEmail") {
      if (value !== formState.email) {
        setErrors((prev) => ({
          ...prev,
          confirmEmail: "E-mail and Confirm e-mail must match.",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          confirmEmail: "", // Clear the error when the emails match
        }));
      }
    }

    if (name === "confirmPassword") {
      if (value !== formState.userPassword) {
        setErrors((prev) => ({
          ...prev,
          confirmPassword: "Password and Confirm Password must match.",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          confirmPassword: "", // Clear the error when the passwords match
        }));
      }
    }

    // Dispatch an action to check if the username or email exists
    if (name === "userName" || name === "email") {
      // if (name === "email" ? formState?.email?.trim()?.length > 0 : formState.userName?.trim()?.length > 0) {
      await dispatch(
        validateUserEmailActions.checkUserNameEmailExists({
          userName: name === "userName" ? formState.userName : "",
          email: name === "email" ? formState.email : "",
        })
      );
      // }
    }
  };


  // Close modal popup Invite Link
  const handlecancelInvite = () => {
    setIsInviteLinkModal(false);
  }

  //  Input controls common onChange event
  const handleChange = (e) => {
    const { name, value } = e.target;

    setCurrentField(name);

    // Define a function to clean values based on field name
    const cleanValue = (name, value) => {
      let cleanedValue = value;

      if (name === "userName") {
        // For userName, remove special characters but allow numbers and letters
        cleanedValue = cleanedValue.replace(/[^A-Za-z0-9]/g, "");
      }

      if (name === "firstName" || name === "lastName") {
        // For firstName and lastName, remove special characters and numbers
        cleanedValue = cleanedValue.replace(/[^A-Za-z]/g, "");
      }

      if (name === "zip") {
        // For ZIP code, remove anything that is not a digit or hyphen (limit to 5 digits)
        cleanedValue = cleanedValue.replace(/[^0-9]/g, "").slice(0, 5);
      }

      if (name === "cellPhone") {
        // For cellPhone, format input as (999) 999-9999
        const cleanedDigits = cleanedValue.replace(/\D/g, ""); // Remove non-digit characters
        const length = cleanedDigits.length;

        // Create formatted phone number
        let formattedValue = "";
        if (length > 0) {
          formattedValue += `(${cleanedDigits.substring(0, 3)}`;
        }
        if (length >= 4) {
          formattedValue += `) ${cleanedDigits.substring(3, 6)}`;
        }
        if (length >= 7) {
          formattedValue += `-${cleanedDigits.substring(6, 10)}`;
        }
        return formattedValue; // Return formatted phone number
      }

      return cleanedValue;
    };

    // Clean the value based on the field name
    const cleanedValue = cleanValue(name, value);

    // Update the form state with the cleaned value
    setFormState((prev) => ({
      ...prev,
      [name]: cleanedValue,
    }));

    // Clear error if the user starts typing and an error was previously present
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const formatDate = (date) => {
    if (date !== null) {
      const d = new Date(date);
      const month = String(d.getMonth() + 1).padStart(2, '0'); // Get month and pad with leading zero if necessary
      const day = String(d.getDate()).padStart(2, '0'); // Get day and pad with leading zero if necessary
      const year = d.getFullYear(); // Get the full year
      return `${month}/${day}/${year}`; // Return the formatted date
    }
    else {
      return null;
    }
  };

  // Helper function to validate the date
  const isValidDate = (date) => {
    return !isNaN(new Date(date).getTime());
  };

  // Helper function to calculate the valid max date (18 years before current date)
  const getMaxValidDate = () => {
    const today = new Date();
    const maxDate = new Date();
    maxDate.setFullYear(today.getFullYear() - 18); // 18 years before today
    return maxDate;
  };

  const onBlur = (e) => {
    let { value } = e.target;
    const minDate = new Date(1900, 0, 1);
    const maxdate = maxDate;
    const formattedDate = value && isValidDate(value)
      ? new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(new Date(value))
      : null;

    if (new Date(value) >= new Date(minDate) && new Date(value) <= new Date(maxdate)) {
      setFormState((prevState) => ({
        ...prevState,
        ['dob']: formatDate(formattedDate), // Update DOB in the parent state
      }));
    } else {
      setFormState((prevState) => ({
        ...prevState,
        ['dob']: null, // Reset date if invalid
      }));
    }
  };

  const handleDateChange = (date, fieldName) => {
    const maxValidDate = getMaxValidDate();
    const minValidDate = new Date(1900, 0, 1); // January 1st, 1990

    // Ensure the date is valid
    const formattedDate = date && isValidDate(date)
      ? new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(new Date(date))
      : null;

    // Check if the formatted date is within the valid range
    if (formattedDate) {
      const selectedDate = new Date(date);
      if (selectedDate >= minValidDate && selectedDate <= maxValidDate) {
        setFormState((prevState) => ({
          ...prevState,
          [fieldName]: formatDate(formattedDate), // Update DOB in the parent state
        }));
      } else {
        // If the date is out of range, reset the input or show a message
        setFormState((prevState) => ({
          ...prevState,
          [fieldName]: null, // Reset date if invalid
        }));
      }
    } else {
      // Reset invalid date
      setFormState((prevState) => ({
        ...prevState,
        [fieldName]: null,
      }));
    }
  };

  const handleDateBlur = (fieldName) => {
    const currentDate = formState[fieldName];
    if (currentDate && !isValidDate(currentDate)) {
      setFormState((prevState) => ({
        ...prevState,
        [fieldName]: null,
      }));
    }
  };

  // JOI validation function
  const validate = async () => {
    try {
      await registerSchema.validateAsync(formState, { abortEarly: false });
      return {};
    } catch (err) {
      const validationErrors = {};
      err.details.forEach((error) => {
        const field = error.path[0]; // Get the actual field name from the error path
        validationErrors[field] = error.message; // Use the correct field name
      });
      return validationErrors;
    }
  };

  // Redirect to login page
  const handleLoginRedirect = () => {
    const infoMessage = "Sign up Page - Clicked into the Login button";
    const redirectURL = "/public/Login";
    const Response = " --- ";
    const Status = "Redirected into the Login Page";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status)
    navigate("/");
  };

  // Register form  submit function
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = await validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const encryptPassword = encryptData(formState?.userPassword);
      try {
        showLoader();
        const searchParams = new URLSearchParams(location.search);
        const inviteLinkUrl = searchParams.get("InviteLink");
        const InviteLink = getStoredValue("IsInvitedURL");

        // Update the condition for isInvitedURL
        const isInvitedURL = Boolean(InviteLink) && inviteLinkUrl && inviteLinkUrl.trim() !== "";
        // Update the formData and isInvitedURL assignment
        const result = await dispatch(
          registerActions.registerUser({
            formData: {
              ...formState,
              userPassword: encryptPassword,
              isRegisteredFromInvite: inmateKioskInvite.IsRegisteredFromInvite,
              inmateInvitePublicUserID: inmateKioskInvite.InmateInvitePublicUserID,
              InviteLink: isInvitedURL ? encodeURIComponent(inviteLinkUrl) : "",
            },
            isInvitedURL: isInvitedURL,
          })
        ).unwrap();
        const infoMessage = "Registered New Public User Account";
        const redirectURL = "public/Register";
        const Response = result || "";
        const Status = "Registered New Public User Account";
        EventLog(dispatch, infoMessage, redirectURL, Response, Status)
      } catch (err) {
        NotificationService({
          title: "Error",
          message: "Registration failed.",
          type: "danger", // can be 'success', 'danger', 'info', 'warning'
        });
      }
    }
  };

  // Register form clear or reset function
  const handleReset = () => {
    showLoader();
    setFormState((prevState) => ({
      ...prevState,
      publicUserID: 0,
      firstName: "",
      lastName: "",
      userName: "",
      userPassword: "",
      email: "",
      cellPhone: "",
      address1: "",
      address2: "",
      city: "",
      stateName: "",
      zip: "",
      dob: null,
      gender: "",
      isAgeVerified: 0,
      isTeamsConditionVerified: false,
      confirmEmail: "",
      confirmPassword: "",
    }));
    setDateOfBirth(null); // Assuming you have a separate state for date of birth
    setErrors({});
    hideLoader();
    setShowPassword(false);
    setShowConfirmPassword(false);
  };

  return (
    <>
      {loader}
      <div className="d-flex min-vh-100">
        <ConfirmationModal
          show={showModal}
          onHide={() => setShowModal(false)}
          onConfirm={modalContent.onConfirm}
          title={modalContent.title}
          messageHTML={modalContent.messageHTML}
          message={modalContent.message}
          showCancelButton={modalContent.showCancelButton}
          onconfirmname="OK"  // Only "OK" button
          oncancelname=""
          size="md p-4"            // Set modal size to large
          closeButton={false}  // Optional: hide close button
        />
        <ReactNotifications />

        <div className="signup-bg">
          <div
            className="d-flex flex-column align-items-center  h-100 text-white p-4"
            style={{ background: "rgba(0, 0, 0, 0.5)" }}
          >
            <div className="d-flex flex-column">
              {/* Logo Image */}
              <img
                src={Logo}
                alt="Logo"
                className="mb-3 me-3 custom-logo" // Margin classes
              />

              {/* Heading and Paragraph */}
              <h2 className="mt-4 mb-3 fs-2">
                Send & Receive Secure Electronic Messages With Your{" "}
                <span className="default-color">Loved</span> Ones
              </h2>
              <p className="fs-5">
                There’s no better way to stay connected with your loved one or
                friend than real-time messages.
              </p>
            </div>
          </div>
        </div>

        <div className="side-bar-signup">

          <div className="p-4">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <div class="d-flex align-items-center ms-auto">

                <span className="" style={{ fontSize: '15px' }}>Existing User?  <span
                  onClick={handleLoginRedirect}
                  className="text-decoration-none text-decoration-none cursor-pointer"
                ><b className="text-default-red text-decoration-underline">Login</b></span>
                </span>
              </div>
            </div>
            <div className="mobile-logo">
              <img src={inmatelogo} width={180} className="mb-4"></img>
            </div>
            <div class="mb-4">
              <h1 class="mb-0">Sign Up</h1>
            </div>
            <div className="card border-radius-all shadow-sm">
              <div className="card-body p-4">
                <form onSubmit={handleSubmit}>
                  <div className="sign-up-header-title mb-3">
                    <label className="">
                      <img className="Login-icons mb-1" src={LockIcon}></img>Login Details
                    </label>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6 col-lg-4 mb-2">
                      <TextInput
                        name="userName"
                        id="userName"
                        label="Username"
                        value={formState.userName}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        placeholder="Username"
                        required={true}
                        errorMessage={errors.userName}
                        maxLength={50}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSubmit(e);
                          }
                        }}
                      />
                    </div>

                    <div className="col-12 col-md-6 col-lg-4 mb-2">
                      <TextInput
                        name="email"
                        id="email"
                        label="E-mail"
                        value={formState.email}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        placeholder="E-mail"
                        required={true}
                        errorMessage={errors.email}
                        maxLength={64}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSubmit(e);
                          }
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 mb-2">
                      <TextInput
                        name="confirmEmail"
                        id="confirmEmail"
                        label="Confirm E-mail"
                        value={formState.confirmEmail}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        placeholder="Confirm E-mail"
                        required={true}
                        errorMessage={errors.confirmEmail}
                        maxLength={64}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSubmit(e);
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6 col-lg-4 mb-2">
                      <PasswordField
                        name="userPassword"
                        id="userPassword" // Ensure the id matches
                        label="Password" // Pass the label text here
                        placeholder="Password"
                        value={formState.userPassword}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errorMessage={errors.userPassword} // Use errorMessage prop
                        required // Mark as required if necessary
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSubmit(e);
                          }
                        }}
                        showPassword={showPassword}
                        setShowPassword={setShowPassword}
                      />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 mb-2">
                      <PasswordField
                        name="confirmPassword"
                        id="userPassword" // Ensure the id matches
                        label="Confirm Password" // Pass the label text here
                        placeholder="Confirm Password"
                        value={formState.confirmPassword}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errorMessage={errors.confirmPassword} // Use errorMessage prop
                        required // Mark as required if necessary
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSubmit(e);
                          }
                        }}
                        showPassword={showConfirmPassword}
                        setShowPassword={setShowConfirmPassword}
                      />
                    </div>
                  </div>
                  <div className="sign-up-header-title mb-3 mt-4">
                    <label className="">
                      <img className="Login-icons" src={userIcon}></img>
                      Personal Information
                    </label>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6 col-lg-4 mb-2">
                      <TextInput
                        name="lastName"
                        id="lastName"
                        label="Last Name"
                        value={formState.lastName}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        placeholder="Last Name"
                        required={true}
                        errorMessage={errors.lastName}
                        maxLength={50}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSubmit(e);
                          }
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 mb-2">
                      <TextInput
                        name="firstName"
                        id="firstName"
                        label="First Name"
                        value={formState.firstName}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        placeholder="First Name"
                        required={true}
                        errorMessage={errors.firstName}
                        maxLength={50}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSubmit(e);
                          }
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 mb-2">
                      <SelectInput
                        options={genderOptions}
                        value={formState.gender}
                        onChange={(selectedOption) =>
                          handleSelectChange(selectedOption, "gender")
                        }
                        name="gender" // Make sure the name is passed
                        labelKey="label"
                        valueKey="value"
                        isClearable={true}
                        placeholder="Select Gender"
                        label="Gender"
                        required={true}
                        handleBlur={handleBlur} // This will now work like with your TextInput
                        errorMessage={errors.gender} // Make sure this is correctly passed
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6 col-lg-4 mb-2">
                      <DatePickerComponent
                        value={formState.dob}
                        onChange={(date) => handleDateChange(date, "dob")}
                        name="dob"
                        label={"DOB"}
                        onBlur={(e) => { onBlur(e) }}
                        maxDate={maxDate}
                        required={false}
                        disabled={false}
                        yearDropDown={true}
                        monthDropDown={true}
                        minDate={new Date(1900, 0, 1)} // January 1st, 1990
                        showTimeSelect={false}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSubmit(e);
                          }
                        }}
                      ></DatePickerComponent>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 mb-2">
                      <TextInput
                        name="address1"
                        id="address1"
                        label="Address 1"
                        value={formState.address1}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        placeholder="Address 1"
                        required={true}
                        errorMessage={errors.address1}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSubmit(e);
                          }
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 mb-2">
                      <TextInput
                        name="address2"
                        id="address2"
                        label="Address 2"
                        value={formState.address2}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        placeholder="Address 2"
                        required={false}
                        errorMessage={errors.address2}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSubmit(e);
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6 col-lg-4 mb-2">
                      <FormatPhoneNumber
                        name="cellPhone"
                        value={formState.cellPhone}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.cellPhone} // Pass error message as needed
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSubmit(e);
                          }
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 mb-2">
                      <TextInput
                        name="city"
                        id="city"
                        label="City"
                        value={formState.city}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        placeholder="City"
                        required={true}
                        errorMessage={errors.city}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSubmit(e);
                          }
                        }}
                      />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 mb-2">
                      <SelectInput
                        options={stateList}
                        value={formState.stateName} // Ensure this reflects the selected state
                        onChange={(selectedOption) =>
                          handleSelectChange(selectedOption, "stateName")
                        }
                        name="stateName" // Make sure the name is passed correctly
                        labelKey="label" // Key for the label in options
                        valueKey="value" // Key for the value in options
                        isMulti={false} // Specify that multiple selections are not allowed
                        closeMenuOnSelect={true} // Close menu after selecting an option
                        isDisabled={false} // Enable the selection
                        isClearable={true} // Allow clearing the selection
                        placeholder="Select State" // Placeholder text
                        label="State" // Label for the select input
                        required={true} // Indicate that this field is required
                        handleBlur={handleBlur} // Handle blur event
                        errorMessage={errors.stateName} // Display errors if any
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6 col-lg-4 mb-4">
                      <TextInput
                        name="zip"
                        id="zip"
                        label="ZIP"
                        value={formState.zip}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        placeholder="ZIP"
                        required={true}
                        errorMessage={errors.zip}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSubmit(e);
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="isTeamsConditionVerified"
                      id="agreementCheckbox"
                      checked={formState.isTeamsConditionVerified}
                      onChange={(e) =>
                        setFormState((prev) => ({
                          ...prev,
                          isTeamsConditionVerified: e.target.checked,
                        }))
                      }
                      onBlur={(e) => {
                        if (!e.target.checked) {
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            isTeamsConditionVerified:
                              "You must agree to the Terms of Service and Privacy Policy.",
                          }));
                        } else {
                          const updatedErrors = { ...errors };
                          delete updatedErrors.isTeamsConditionVerified;
                          setErrors(updatedErrors);
                        }
                      }}
                    />

                    <label className="form-check-label" htmlFor="agreementCheckbox">
                      {/* <input
                      type="checkbox"
                      className="form-check-input"
                      id="termsCheckbox"
                      style={{ marginRight: "8px" }}
                    /> */}
                      I have read and agreed to{" "}
                      <a
                        href="/termsofservice"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="default-color"
                        onClick={() => {
                          const infoMessage = "Public User clicked into the Terms of Service link button";
                          const redirectURL = "/termsofservice";
                          const Response = " --- ";
                          const Status = "Redirected into Terms of Service page";
                          EventLog(dispatch, infoMessage, redirectURL, Response, Status)
                        }}
                      >
                        <span className="default-color">Terms of Service</span>
                      </a>{" "}
                      and{" "}
                      <a
                        href="/privacypolicy"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="default-color"
                        onClick={() => {
                          const infoMessage = "Public User clicked into the Privacy Policy link button";
                          const redirectURL = "/privacypolicy";
                          const Response = " --- ";
                          const Status = "Redirected into Privacy Policy page";
                          EventLog(dispatch, infoMessage, redirectURL, Response, Status)
                        }}
                      >
                        <span className="default-color">Privacy Policy</span>
                      </a>
                      .
                    </label>

                    {errors.isTeamsConditionVerified && (
                      <p className="text-danger fw-700 font-size-14">{errors.isTeamsConditionVerified}</p>
                    )}
                  </div>
                  <div className="form-check mb-4">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="isAgeVerified"
                      id="ageCheckbox"
                      checked={formState.isAgeVerified === 1}
                      onChange={(e) =>
                        setFormState((prev) => ({
                          ...prev,
                          isAgeVerified: e.target.checked ? 1 : 0,
                        }))
                      }
                      onBlur={(e) => {
                        if (!e.target.checked) {
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            isAgeVerified: "You must confirm that you are above 18 years old.",
                          }));
                        } else {
                          const updatedErrors = { ...errors };
                          delete updatedErrors.isAgeVerified;
                          setErrors(updatedErrors);
                        }
                      }}
                    />

                    <label className="form-check-label" htmlFor="ageCheckbox">
                      Are you above 18 years?
                    </label>
                    {errors.isAgeVerified && (
                      <p className="text-danger fw-700 font-size-14">{errors.isAgeVerified}</p>
                    )}
                  </div>

                  <div className="d-flex justify-content-start mt-4">
                    <button
                      type="submit"
                      className="btn btn-theme d-block w-10 mb-2 font-size-14"
                    >
                      <i class="fa-solid fa-check me-1"></i>
                      Submit
                    </button>
                    <button
                      type="button"
                      className="btn btn-grey ms-2 font-size-14 mb-2"
                      onClick={handleReset}
                    >
                      <i className="fa-solid fa-arrow-rotate-left me-1"></i>
                      Reset
                    </button>
                  </div>
                </form>
              </div>
              <ToastContainer />
            </div>
          </div>
        </div>


        <ConfirmationModal
          show={isInviteLinkModal}
          onHide={handlecancelInvite}
          onConfirm={handlecancelInvite}
          title="Message"
          message="Incorrect Invite Link"
          closeButton={false}
          onconfirmname={"Ok"}
          showCancelButton={false}
        />
      </div>
    </>
  );
}

export default React.memo(Register);
